export default __webpack_public_path__ + "static/media/siteLogo.bc6a11df.png";